import { Component, OnInit, signal } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, RouterLink } from '@angular/router';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from 'src/app/app.component';
import { CustomValidators } from 'angular-custom-validators';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    NgxIntlTelInputModule,
    MatError,
    MatButton,
    RouterLink,
    MatIcon,
  ],
})
export class ResetPasswordComponent implements OnInit {
  resetForm: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [CustomValidators.email, Validators.required]),
  });
  awaitingResponse = signal(false);

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {}

  async resetPassword() {
    if (!this.resetForm.controls.email.valid || this.awaitingResponse()) {
      this.snackBar.open('Vul een geldig e-mailadres in.', 'X');
      return;
    }
    this.awaitingResponse.set(true);
    try {
      await sendPasswordResetEmail(auth, this.resetForm.value.email, {
        url: `${window.location.origin}/auth/login`,
      });
      this.awaitingResponse.set(false);
      this.snackBar.open('Er wordt een e-mail gestuurd om je wachtwoord te herstellen.', 'X');
    } catch (error) {
      this.awaitingResponse.set(false);
      console.error('error', error);
      this.snackBar.open('Er is een onbekende fout opgetreden. Probeer het later opnieuw.', 'X');
    }
  }
}
